<app-navbar title="Produkty">
	<button mat-raised-button routerLink="./add" color="primary" class="me-4"><i class="fas fa-plus"></i> Dodaj</button>
</app-navbar>
<div class="row filters-row m-2">
	<div class="col-md-10">
		<input
			type="text"
			class="form-control w-100"
			(keyup)="refreshFilter()"
			[(ngModel)]="filterValue"
			placeholder="Filtrowanie (min. 3 znaki)"
		/>
	</div>
	<div class="col-md-2 text-center">
		<button class="me-4" mat-raised-button color="primary" (click)="filtersOpen()">
			<i class="fas fa-filter"></i>
		</button>
	</div>
</div>
<app-products-list-filters
	userFilters="product"
	[type]="parameters.type"
	[allTags]="parameters.tags"
	[location]="parameters.location"
	(selected)="filtersSelected($event)"
	[forceFilters]="{ limit: 9999 }"
></app-products-list-filters>

<ng-container *ngIf="showTable">
	<mat-table
		[dataSource]="matData"
		matSort
		matSortActive="id"
		matSortDirection="asc"
		grouping="false"
		cdkDropList
		cdkDropListDisabled="true"
	>
		<ng-container matColumnDef="position">
			<mat-header-cell *matHeaderCellDef> LP </mat-header-cell>
			<mat-cell *matCellDef="let element; let i = index">{{ i + 1 }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="id">
			<mat-header-cell *matHeaderCellDef mat-sort-header> ID </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.id }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="code">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Kod </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.code }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="name">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Nazwa </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.name }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="type">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Typ </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.type }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="tags">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Tagi </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.tags }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="locationsName">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Lokalizacja </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.locationsName }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="status">
			<mat-header-cell
				*matHeaderCellDef
				mat-sort-header
				matTooltip="SZKIC -	świeżo utworzony, w trakcie przygotowania przez działy
			możliwość ręcznej zmiany z AKTYWNY, ARCHIWUM
		 
			OPUBLIKOWANY - posiadający aktualną ofertę- 
			automatycznie zmienia na ten status o ile są wypełnione wszystkie wymagane pola
			brak możliwości ręcznej zmiany na ten status
		 
			AKTYWNY - sprawdzony pod względem merytorycznym ale nieposiadający aktualnej oferty 
			możliwość ręcznej zmiany z SZKIC, ARCHIWUM ale ! przy weryfikacji systemu czy wszystkie pola są wypełnione
			
			ARCHIWUM - produkt który biznesowo nie jest już w naszym katalogu a nie chcemy żeby nas zaśmiecał np.Willa Blue Moon -
			możliwość ręcznej zmiany z SZKIC, AKTYWNY
			"
			>
				Status
			</mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.status }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="edit">
			<mat-header-cell *matHeaderCellDef></mat-header-cell>
			<mat-cell *matCellDef="let element">
				<button mat-raised-button color="primary" routerLink="/product/{{ element.id }}/">Edytuj</button>
			</mat-cell>
		</ng-container>
		<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
		<mat-row *matRowDef="let row; columns: displayedColumns" cdkDrag></mat-row>
	</mat-table>
	<mat-paginator
		class="fixed-bottom"
		style="z-index: 0"
		[pageSizeOptions]="[20, 30, 50]"
		showFirstLastButtons
		aria-label="Select page of periodic elements"
	>
	</mat-paginator>
</ng-container>
